import { connect } from "react-redux";
import get from "lodash/get";

import { getUnitsReport as onGetUnitsReport, clearUnitReport as onClearUnitReport } from "../../actions/unitReportActions";

const mapStateToProps = (state) => ({
  unitReportDataState: state.unitReport.dataState,
  unitsReportData: get(state, ["unitReport", "data"], { units: [], pivot: [], reportData: null }),
  unitReportErrors: get(state, ["unitReport", "errors"], []),
  isUnitReportCanceled: state.unitReport.isCanceled,
  cancelUnitReport: state.unitReport.cancel,
});

const mapDispatchToProps = {
  onGetUnitsReport,
  onClearUnitReport,
};

const withUnitReport = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withUnitReport };
